import { render, staticRenderFns } from "./ContentComments.vue?vue&type=template&id=7e16eb3c&scoped=true"
import script from "./ContentComments.vue?vue&type=script&lang=js"
export * from "./ContentComments.vue?vue&type=script&lang=js"
import style0 from "./ContentComments.vue?vue&type=style&index=0&id=7e16eb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e16eb3c",
  null
  
)

export default component.exports